import { render, staticRenderFns } from "./BaseLayout.pug?vue&type=template&id=49aa07f3&scoped=true&lang=pug&"
import script from "./BaseLayout.js?vue&type=script&lang=js&"
export * from "./BaseLayout.js?vue&type=script&lang=js&"
import style0 from "./BaseLayout.sass?vue&type=style&index=0&id=49aa07f3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49aa07f3",
  null
  
)

component.options.__file = "BaseLayout.vue"
export default component.exports